import { useCallback, useEffect, useState } from "react";

export const STREAM_CHAT_PREFERENCE_STORAGE_KEY =
  "kledo:supervisorStreamChatEnabled";

/** Baca preferensi langsung dari localStorage (aman dipakai di handler / callback). */
export function readStreamChatPreferenceEnabled() {
  if (typeof window === "undefined") return false;
  try {
    return localStorage.getItem(STREAM_CHAT_PREFERENCE_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

function readStored() {
  if (typeof window === "undefined") return false;
  try {
    return localStorage.getItem(STREAM_CHAT_PREFERENCE_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

export default function useStreamChatPreference() {
  const [enabled, setEnabledState] = useState(false);

  useEffect(() => {
    setEnabledState(readStored());
  }, []);

  const setEnabled = useCallback((next) => {
    setEnabledState(next);
    try {
      localStorage.setItem(
        STREAM_CHAT_PREFERENCE_STORAGE_KEY,
        next ? "true" : "false"
      );
    } catch {
      // ignore quota / private mode
    }
  }, []);

  return { enabled, setEnabled };
}
